import { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import moment from "moment-timezone";
import { getSocket } from '../context/socket';
import { useAuth } from '../context/AuthContext';

function toIstWallClockString(value) {
    if (!value) return null;
    const m = moment(value);
    return moment
        .tz(
            {
                year: m.year(),
                month: m.month(),
                date: m.date(),
                hour: m.hour(),
                minute: m.minute(),
                second: m.second(),
            },
            'Asia/Kolkata'
        )
        .format('YYYY-MM-DD HH:mm:ss');
}

const DeadlinePopup = ({ onCancel, cardDetails, togglePopup, cardId, boardId }) => {
    const socket = getSocket();
    const { userId } = useAuth();

    const [dueDate, setDueDate] = useState(null);
    const [reminderDate, setReminderDate] = useState(null);
    const [saving, setSaving] = useState(false);
    const [saveError, setSaveError] = useState('');


    useEffect(() => {
        if (cardDetails) {
            setDueDate(
                cardDetails.due_date
                    ? moment.tz(cardDetails.due_date, "Asia/Kolkata").toDate()
                    : null
            );
            setReminderDate(
                cardDetails.reminder_date
                    ? moment.tz(cardDetails.reminder_date, "Asia/Kolkata").toDate()
                    : null
            );
        }
    }, [cardDetails]);





    const handleSave = () => {
        if (!socket) {
            setSaveError('Connection lost. Please refresh and try again.');
            return;
        }

        const dueDateIST = toIstWallClockString(dueDate);
        const reminderDateIST = reminderDate
            ? moment(reminderDate).startOf('day').tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss')
            : null;

        setSaving(true);
        setSaveError('');

        socket.emit(
            'updateCardDates',
            {
                card_id: cardId,
                board_id: boardId,
                user_id: userId,
                due_date: dueDateIST,
                reminder_date: reminderDateIST,
            },
            (response) => {
                setSaving(false);
                if (response?.success) {
                    onCancel();
                    return;
                }
                setSaveError(response?.error || 'Failed to save due date.');
            }
        );
    };


    const handleRemove = () => {
        onCancel();
    };

    return (
        <div className="popup-box popup-dates">
            <div className="popup-header">
                Dates
                <Button icon="pi pi-times" className="p-button-text close-btn" onClick={() => togglePopup("dates")} />
            </div>
            <div className="popup-body">
                <div className="list-EmpLIst">
                    <p className="text-muted mb-1"><small>Set Deadline Date</small></p>
                    <Calendar
                        value={dueDate}
                        onChange={(e) => {
                            console.log("New due date selected:", e.value);
                            setDueDate(e.value);
                        }}
                        placeholder="Select due date"
                        dateFormat="dd-mm-yy"
                        showTime
                        hourFormat="12"
                        className="mb-3"
                        minDate={new Date()} // ⬅️ disables all past dates
                    />

                    <p className="text-muted mb-1"><small>Set Reminder Date</small></p>
                    <Calendar
                        value={reminderDate}
                        onChange={(e) => setReminderDate(e.value)}
                        placeholder="Select reminder date"
                        dateFormat="dd-mm-yy"
                        className="mb-3"
                        minDate={new Date()} // ⬅️ disables all past dates
                    />

                    <Button
                        label={saving ? 'Saving…' : 'Save'}
                        severity="primary"
                        className="border-0 py-1 px-3 mt-2 me-2"
                        disabled={saving}
                        onClick={handleSave}
                    />
                    <Button label="Cancel" severity="danger" className="border-0 py-1 px-3 mt-2 opacity-75" onClick={handleRemove} disabled={saving} />
                </div>
                {saveError && <p className="text-danger small mt-2 mb-0">{saveError}</p>}
            </div>
        </div>
    );
};

export default DeadlinePopup;
